export default __webpack_public_path__ + "static/media/six.05802ba9.png";